import emptyNotifications from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  NOTIFICATION: {
    LIST_ALL: {
      REFRESH: 'NOTIFICATION_LIST_ALL_REFRESH',
      REFRESHING: 'NOTIFICATION_LIST_ALL_REFRESHING',
      REFRESHED: 'NOTIFICATION_LIST_ALL_REFRESHED',
      REFRESH_ERROR: 'NOTIFICATION_LIST_ALL_REFRESH_ERROR'
    },
    CREATE_OR_UPDATE: {
      SHOW: 'NOTIFICATION_CREATE_OR_UPDATE.SHOW'
    },
    SUBMIT: 'NOTIFICATION.SUBMIT',
    DELETE: 'NOTIFICATION.DELETE',
    UPDATE: 'notification.update',
    UPDATED: 'notification.updated'
  }
};

export const ENDPOINTS = {
  NOTIFICATION: {
    GET_LIST:
      '/store/app/data?service={lacasaeBettingServiceName}&userId={lacasaeBettingServiceName}-notifications&group=lacasae',
    UPDATE:
      '/store/app/data?service={lacasaeBettingServiceName}&userId={lacasaeBettingServiceName}-notifications&group=lacasae'
  }
};

export const NOTIFICATION = {
  COUNTRIES: {
    ANY: { name: 'Tous les pays', flag: '🌍' },
    BJ: { name: 'Bénin', flag: '🇧🇯' },
    BF: { name: 'Burkina Faso', flag: '🇧🇫' },
    CI: { name: "Côte d'Ivoire", flag: '🇨🇮' },
    ML: { name: 'Mali', flag: '🇲🇱' },
    GA: { name: 'Gabon', flag: '🇬🇦' },
    SN: { name: 'Sénégal', flag: '🇸🇳' },
    TG: { name: 'Togo', flag: '🇹🇬' }
  },

  LOTTIES: {
    EMPTY: emptyNotifications,
    LOADING_ERROR: loadingError
  }
};
